import { getCordova, InAppBrowserEvent, InAppBrowser } from '../cordova';
import { AppChannelMessages } from '@hoylu/login-common';
import { resolveResponse, trace } from '../index';
import { promiseCallback, promiseFailure } from "../types";

export function createPopup(
    loginHost: string,
    loginRoute: string,
    resolve: promiseCallback,
    reject: promiseFailure) {
    const width = 397;
    const height = 590;
    const top = window.innerHeight / 2 - height / 2 + window.screenY;
    const left = window.innerWidth / 2 - width / 2 + window.screenX;

    const url = loginHost + loginRoute;
    const target = window.location.origin;
    const options = `toolbar=no,location=no,directories=no,status=no,
                   menubar=no,copyhistory=no,
                   width=${width},height=${height},top=${top},left=${left}`;

    const cordovaBrowser = getCordova()?.InAppBrowser;

    if (cordovaBrowser) {
        cordovaInAppBrowserPopup(cordovaBrowser);
    } else {
        normalBrowserPopup();
    }

    function normalBrowserPopup(): void {
        // Native Browser Window Implementation
        let loginAppWindow = window.open(url, target, options);

        const timer = setInterval(() => {
            if (loginAppWindow?.closed) {
                clearInterval(timer);
                return reject('session closed by user');
            }
        }, 1000);

        window.addEventListener('message', (e: MessageEvent) => {
            if (loginHost !== e.origin)
                return;

            if (e.data.status) {
                loginAppWindow?.close();
                resolveResponse(e.data, resolve, reject);
            } else if (e.data === AppChannelMessages.APP_READY_MESSAGE) {
                loginAppWindow?.postMessage(AppChannelMessages.TARGET_ORIGIN_MESSAGE, loginHost);
            } else {
                trace('Received unknown message', e);
            }
        });
    }

    function cordovaInAppBrowserPopup(cordovaBrowser: InAppBrowser): void {
        trace('detected and use Cordova InAppWindow plugin');
        let loginAppWindow = cordovaBrowser.open(url, target, options);
        loginAppWindow.addEventListener('loadstop', () => {
            // replace postMessage funtion with the InAppWindow one, since postMessage in the InAppBrowser does not work.
            loginAppWindow.executeScript({
                code: 'window.postMessage = (m) => webkit.messageHandlers.cordova_iab.postMessage(JSON.stringify(m));'
            });
        });
        const userCancelHandler = () => reject('session closed by user');
        loginAppWindow.addEventListener('exit', userCancelHandler);

        const messageHandler = (e: InAppBrowserEvent) => {
            trace(`Got message via InAppBrowser postMessage: ${e}`);
            if (e.data && e.data.status) {
                loginAppWindow?.removeEventListener('exit', userCancelHandler);
                loginAppWindow?.removeEventListener('message', messageHandler);
                loginAppWindow?.close();
                resolveResponse(e.data, resolve, reject);
            }
        };
        loginAppWindow.addEventListener('message', messageHandler);
    }
}
